import { SignJWT } from "jose";
import { getSecretByName } from "../redux/action/keyVaultAction";

export async function encryptJWT(userId, dispatch) {
    const secret = process.env.REACT_APP_IS_AZURE_VAULT
        ? process.env.REACT_APP_JWT_TOKEN_SECRET
        : await dispatch(getSecretByName("JWT-SECRET"));

    const SECRET_KEY = new TextEncoder().encode(secret);

    const token = await new SignJWT({ id: userId })
        .setProtectedHeader({ alg: "HS256", typ: "JWT" })
        .setIssuedAt()
        .setExpirationTime("1h")
        .sign(SECRET_KEY);

    return token;
}
